import { c as _c } from "react/compiler-runtime";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { useTeamMenuOptions } from "@pages/members/teams/use-team-menu-options";
/**
 * Renders a 3-dot menu with actions for a single team row in the table.
 */
export function TeamOptionsMenu(t0) {
  const $ = _c(6);
  const {
    team,
    shouldExcludeRemove,
    memberToRemove
  } = t0;
  let t1;
  if ($[0] !== memberToRemove || $[1] !== shouldExcludeRemove) {
    t1 = {
      shouldExcludeRemove,
      memberToRemove
    };
    $[0] = memberToRemove;
    $[1] = shouldExcludeRemove;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const menuItems = useTeamMenuOptions(t1);
  let t2;
  if ($[3] !== menuItems || $[4] !== team) {
    t2 = <ListItemMenu item={team} menuItems={menuItems} />;
    $[3] = menuItems;
    $[4] = team;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}